import { Action, Dispatch } from "redux";
import loadIdentity from "./loadIdentity";
import { actionTypes, apiStatuses, Deferred, InitializeSpid, userLoggedInDeferred } from "./Actions";
import { IHasSessionFailureResponse, IHasSessionSuccessResponse } from "@schibsted/account-sdk-browser";

function isIHasSessionSuccessResponse(
  r: IHasSessionSuccessResponse | IHasSessionFailureResponse
): r is IHasSessionSuccessResponse {
  return (r as IHasSessionSuccessResponse).result;
}

const initializeSpid: InitializeSpid = () => (
  dispatch: Dispatch<Action>
) => {
  const deferred = new Deferred();
  dispatch({ type: actionTypes.SET_SESSION_INFO, status: apiStatuses.LOADING });

  const failedCallback = (data: any) => {
    deferred.reject(data);
    return dispatch({
      data,
      status: apiStatuses.ERROR,
      type: actionTypes.SET_SESSION_INFO
    });
  };

  loadIdentity()
    .then(identity => identity.hasSession())
    .then(data => {
      if (isIHasSessionSuccessResponse(data)) {
        dispatch({
          data,
          status: apiStatuses.SUCCESS,
          type: actionTypes.SET_SESSION_INFO
        });
        deferred.resolve(data);
        userLoggedInDeferred.resolve({ spidId: data.userId, sig: data.sig });
      } else {
        if (data.userStatus === 'notConnected') {
          dispatch({
            data,
            status: apiStatuses.SUCCESS,
            type: actionTypes.SET_SESSION_INFO
          });
          deferred.resolve(data);
        } else {
          failedCallback(data);
        }
      }
    })
    .catch(failedCallback);

  return deferred.promise;
};

export default initializeSpid;
